// extracted by mini-css-extract-plugin
module.exports = {"selected":"ProductInput_selected__TFzt8","header":"ProductInput_header__fL21U"};